module.exports = __webpack_public_path__ + "static/media/dark-layout-bg.b86ac8d9.png";